import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Helpers } from '../../helpers';
import { AuthenticationService } from '../_services/authentication.service';


@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  encapsulation: ViewEncapsulation.None,
})

export class LogoutComponent implements OnInit {

  constructor(private _authService: AuthenticationService) {
  }

  ngOnInit(): void {
    Helpers.setLoading(true);
    // reset login status
    // this._authService.logout();
    this._authService.unauthorized();
  }
}
